import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Check, Zap, Shield, Cpu, Server, Activity } from "lucide-react";
export default function Products() {
  const tiers = [{
    name: "Master",
    price: "$1,500",
    period: "/Set-up Fee",
    desc: "Website design and project management.",
    features: ["Develop Brand Guidelines\xA0", "Custom Website Concept Sketches", "Material Sourcing", "Monthly Progress Review"],
    highlight: false,
    cta: "Inquire Now",
    url: "/OurServicesPage",
    icon: <Cpu className="w-5 h-5" />
  }, {
    name: "Pro",
    price: "$2,199",
    period: "/Set-up Fee",
    desc: "Comprehensive website design, branding and project management.",
    features: ["Full Schematic Design", "Custom Website Concept Framework", "Interior Curation", "Priority Site Visits", "Contractor Coordination"],
    highlight: true,
    cta: "Begin Journey",
    url: "/OurServicesPage",
    icon: <Zap className="w-5 h-5" />
  }, {
    name: "Authority + Merchant",
    price: "Custom",
    period: "",
    desc: "The pinnacle of multi-breed website presence making your vision and merchant sales come alive.",
    features: ["Full Lifecycle Management", "International Procurement", "Product Set-up", "Custom Fabrication", "Unlimited Consultations"],
    highlight: false,
    cta: "Private Consultation",
    url: "/ServiceApplicationAndAppointmentSchedulingPage",
    icon: <Shield className="w-5 h-5" />
  }];
  return;
}